export default __webpack_public_path__ + "static/Second-fe59d2229634631ae927b7cbfb4f5333.jpg";